import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paper, Stack, Typography } from "@mui/material";
import DistributorSelection from "../../Components/DistributorSelection";
import ProductSelection from "../../Components/ProductSelection";
import { useDistributorsContext } from "../../Contexts/distributorsContext";

export default function ProductSettingsSelect() {
    const navigate = useNavigate();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const { setSelectedDistributor } = useDistributorsContext();

    useEffect(() => {
        setSelectedDistributor(null);
    }, [setSelectedDistributor]);

    const handleProductChange = (event, product) => {
        setSelectedProduct(product);
        if (product) {
            navigate(`/productSettings/${product.sku}`);
        }
    };

    const handleDistributorChange = (distributor) => {
        if (distributor) {
            navigate(`/distributorSettings/${distributor.distributorId}`);
        }
    };

    return (
        <Paper elevation={1} sx={{ padding: 2, margin: 2 }}>
            <Stack direction="column" spacing={2}>
                <Typography variant="h4">Product Settings</Typography>
                <Stack direction="row" spacing={2}>
                    <DistributorSelection filterByCanOrderBeer onChange={handleDistributorChange} />
                    <ProductSelection value={selectedProduct} onChange={handleProductChange} />
                </Stack>
            </Stack>
        </Paper>
    );
}
